export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (!error || typeof error !== 'object') {
    return fallback;
  }

  const axiosError = error as {
    response?: { data?: { message?: string } };
    message?: string;
  };

  return axiosError.response?.data?.message || axiosError.message || fallback;
}
